import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Clienthad() {
  return (
    <section className="client_had p-100 text_milo">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Project Idea and Goals Set <span>for TekRevol</span>
            </h2>
            <p>
              TekRevol’s objective with MiloCare+ was to develop an iOS and
              Android app that prioritized user-oriented health record
              management. The main goal was to offer a flawless, secure way for
              individuals aged 18 and above to access and manage health records,
              with an explicit focus on Covid test results and vaccination
              records. Moreover, TekRevol intended to cover this functionality
              to contain family members under 18, providing a complete health
              data management solution.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <div className="client_img_milo">
              <StaticImage
                src="../../../images/case-studies/milocare/project-idea.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={475}
                height={608}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clienthad;
